import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Styles from './PrevArrow.module.scss';

interface PrevArrowProps {
  style?: any;
  onClick?: (e: React.FormEvent<HTMLDivElement>) => void;
}
const PrevArrow: FunctionComponent<PrevArrowProps> = (props: PrevArrowProps) => {
  const { style, onClick } = props;
  const left: any = faAngleLeft;
  return (
    <div
      className={`prev-arrow ${Styles.arrowButton}`}
      style={style}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex={0}
    >
      <FontAwesomeIcon icon={left} />
    </div>
  );
};

export default PrevArrow;
